module.exports = __webpack_public_path__ + "h5/img/primary_product.61640fe8.jpg";